<template>
  <div class="ht-container ht-container-admin pb-5">
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
class ManageRooms extends Vue {

}
export default ManageRooms;
</script>

<style scoped>

</style>
